document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-close]').forEach(x=>x.addEventListener('click',()=>x.closest('dialog')?.close()));

  document.querySelectorAll('[data-tt-hero]').forEach(hero=>{
    const slides=[...hero.querySelectorAll('[data-tt-hero-slide]')];
    if(slides.length<2) return;
    let index=0;
    const delay=parseInt(hero.dataset.autoplay||5000,10);
    const show=(next)=>{
      slides[index]?.classList.remove('is-active');
      index=next % slides.length;
      slides[index]?.classList.add('is-active');
    };
    let timer=setInterval(()=>show(index+1),delay);
    hero.addEventListener('mouseenter',()=>clearInterval(timer));
    hero.addEventListener('mouseleave',()=>{timer=setInterval(()=>show(index+1),delay);});
  });
});